<template>
  <v-modal v-if="isShown" x-short @close="handleClose">
    <template slot="#scheduled">
      <div class="text-center p-5">
        <v-icon icon="schedule" class="text-grey-60" size="3rem" />

        <h2 class="mb-2">
          {{
            $t(
              "components.modals.scheduleContentModalTrigger.contentNotAvailable"
            )
          }}
        </h2>
        <p class="mt-0 lead">
          {{ $t("components.modals.scheduleContentModalTrigger.availableIn") }}
          <strong>{{ availableIn }}</strong>
        </p>
      </div>
    </template>
  </v-modal>
</template>

<script>
import EventBus, { EVENTS } from "@/lib/event-bus"
import { timeAgo } from "@/lib/date-utils"

export default {
  data() {
    return {
      isShown: false,
      availableIn: null,
      pageTitle: ""
    }
  },

  methods: {
    handleClose() {
      this.$router.removeHash()
      this.isShown = false
    }
  },

  mounted() {
    EventBus.$on(EVENTS.TRIGGER_SCHEDULED_MODAL, availableAfter => {
      this.isShown = true
      this.$router.push("#scheduled")
      this.availableIn = timeAgo(availableAfter, true)
    })
  }
}
</script>
